import React, {useState, useEffect, useRef, useImperativeHandle} from "react";
import axios from "axios";
import {ButtonsFooter} from "../Components/Atoms/ButtonFooter";
import {InputSelectListCardContainer} from "../Components/InputSelectListCard/InputSelectListCardContainer";
import {TriviasList} from "../Components/Atoms/TriviasList";
import {InputListCard} from "../Components/InputListCard/InputListCard";

export const withEditableMeetCompany = (
    cardName,
    profileId,
    authToken,
    urlApi,
    authEpid,
    trivias,
    informationList,
    socialMediaList,
    otherSocialMedia,
    customerOfficeAdressList,
    seoArticles,
    cancelActionHandler,
    saveActionHandler,
    refreshProfile,
    setopenInprogress,
    ref
) => {
    return (props) => {
        const inputListCard1Ref = useRef(null);
        const inputListCard2Ref = useRef(null);
        const inputListCard3Ref = useRef(null);
        const inputListCard4Ref = useRef(null);
        const inputListCard5Ref = useRef(null);
        const inputListCard6Ref = useRef(null);

        const config = {
            headers: {accept: "*/*", Authorization: `Bearer ${authToken}`},
        };


        const [changed, setChanged] = useState(false);
        const [companySocialChanges, setCompanySocialChanges] = useState();

        const isChanged = () => {
            if (changed
                || inputListCard2Ref.current?.isChanged()
                || inputListCard3Ref.current?.isChanged()
                || inputListCard4Ref.current?.isChanged()
                || inputListCard5Ref.current?.isChanged()
                || inputListCard6Ref.current?.isChanged()
                )
            {
                return true;
            } else {
                return false;
            }
        }

        const onChangeSocialMedia = (changes) => {
            setChanged(true)
            setCompanySocialChanges({...companySocialChanges, ...changes})
        }

        const onSaveSocialMediaChanges = () => {
            const payload = {
                id: profileId,
                ePid: authEpid,
                ...companySocialChanges,
            };
            if (companySocialChanges) {
                axios.patch(`${urlApi}/profile`, payload, config)
                    .then((res) => {
                        refreshProfile();

                    });
            }
            saveActionHandler();
            setChanged(false);
        }

        const addMetadata = (header, text, category) => {
            setChanged(true);
            const body = [{category: category, /**order: 0,*/ key: header, stringValue1: text}];
            axios
                .put(`${urlApi}/metadata/${profileId}`, body,
                    config,
                )
                .then((res) => {
                    const data = res.data;
                    refreshProfile();
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        const deleteSocialItem = (rowId) => {
            setChanged(true);
            const delConfig = {
                headers: {accept: "*/*", Authorization: `Bearer ${authToken}`},
                data: [rowId],
            };
            axios
                .delete(`${urlApi}/metadata/${profileId}`,
                    delConfig,
                )
                .then((res) => {
                    const data = res.data;
                    refreshProfile();
                })
                .catch((err) => {
                    console.log(err);
                });

        }

        useImperativeHandle(ref, () =>
            ({
                save: onSaveSocialMediaChanges,
                isChanged: isChanged
            })
        );

        const onComponentIsComplete = () => {
            setChanged(false);
        }

        return (
            <InputSelectListCardContainer
                cardName={cardName}
                inputListCard1={
                    <InputListCard
                        itemList={socialMediaList}
                        onChangeActionHandler={onChangeSocialMedia}
                        saveActionHandler={onSaveSocialMediaChanges}
                        cancelActionHandler={cancelActionHandler}
                        emitComponentIsComplete={onComponentIsComplete}
                    />
                }
                inputListCard2={
                    <TriviasList
                        header="Kanały social media"
                        textList={otherSocialMedia}
                        label1="Nazwa kanału"
                        label2="Adres internetowy"
                        addHandler={(val1, val2) => addMetadata(val1, val2, "Kanały socialmedia")}
                        deleteHandler={deleteSocialItem}
                        ref={inputListCard2Ref}
                    />
                }
                inputListCard3={
                    <TriviasList
                        header="Poznaj firmę od podszewki"
                        textList={informationList}
                        label1="Nagłówek"
                        label2="Treść"
                        addHandler={(val1, val2) => addMetadata(val1, val2, "Poznaj firme")}
                        deleteHandler={deleteSocialItem}
                        ref={inputListCard3Ref}
                    />
                }
                inputListCard4={
                    <TriviasList
                        header="Ciekawostki"
                        textList={trivias}
                        label1="Nagłówek"
                        label2="Treść"
                        addHandler={(val1, val2) => addMetadata(val1, val2, "Ciekawostki")}
                        deleteHandler={deleteSocialItem}
                        ref={inputListCard4Ref}
                    />
                }

                inputListCard5={
                    <TriviasList
                        header="Adresy biur obsługi klienta"
                        textList={customerOfficeAdressList}
                        label1="Ulica, numer domu"
                        label2="Miasto"
                        addHandler={(val1, val2) => addMetadata(val1, val2, "Adresy biur")}
                        deleteHandler={deleteSocialItem}
                        ref={inputListCard5Ref}
                    />
                }

                inputListCard6={
                    window.isAdmin &&
                    <TriviasList
                        header="Artykuły SEO"
                        textList={seoArticles}
                        label1="Nagłówek"
                        label2="Treść"
                        addHandler={(val1, val2) => addMetadata(val1, val2, "Artykuły SEO")}
                        deleteHandler={deleteSocialItem}
                        ref={inputListCard6Ref}
                    />
                }
                buttonsFooter={
                    <ButtonsFooter
                        saveActionHandler={onSaveSocialMediaChanges}
                        cancelActionHandler={cancelActionHandler}
                        isAnulujVisible={true}
                        acceptText="Akceptuj"

                    />
                }
            />
        );
    };
};
